// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"43":"python","443":"about","767":"details"}[chunkId] + "." + {"43":"69f26bdd","443":"573f4802","767":"c5f51199"}[chunkId] + ".js";
};